import { EllipsisVerticalIcon } from '@heroicons/react/24/outline'
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from '@/components/ui/dropdown-menu'

export const SecondaryActionsButton = ({
  stepNumber,
  onDelete,
  onRename,
}: {
  stepNumber: number
  onDelete: () => void
  onRename: () => void
}) => {
  return (
    <DropdownMenu modal={false}>
      <DropdownMenuTrigger
        className="px-1 py-2 rounded-lg hover:bg-gray-100"
        data-testid={`step-card-${stepNumber}-options-button`}
        onClick={(e) => {
          e.preventDefault()
          e.stopPropagation()
        }}
      >
        <EllipsisVerticalIcon className="w-4 h-4 text-gray-500" />
      </DropdownMenuTrigger>
      <DropdownMenuContent>
        <DropdownMenuItem
          data-testid={`step-card-${stepNumber}-delete-button`}
          onSelect={(e) => {
            e.stopPropagation()
            onDelete()
          }}
        >
          Delete
        </DropdownMenuItem>
        <DropdownMenuItem
          onSelect={(e) => {
            e.stopPropagation()
            onRename()
          }}
        >
          Rename
        </DropdownMenuItem>
      </DropdownMenuContent>
    </DropdownMenu>
  )
}
